import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#D4AF37', // Premium Gold
            light: '#E5C76B',
            dark: '#B38F1C',
            contrastText: '#000000',
        },
        secondary: {
            main: '#FFD700', // Gold Highlight
            light: '#FFE44D',
            dark: '#C7A600',
            contrastText: '#000000',
        },
        background: {
            default: '#111111',
            paper: '#1A1A1A',
        },
        text: {
            primary: '#F5F5F5', // Slightly off-white
            secondary: '#BDBDBD',
        },
    },
    typography: {
        fontFamily: 'Playfair Display, Roboto, Arial, sans-serif',
        h4: {
            fontWeight: 600,
            letterSpacing: '0.02em',
        },
        h5: {
            fontWeight: 500,
            letterSpacing: '0.01em',
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.6,
        },
        body2: {
            fontSize: '0.9rem',
            lineHeight: 1.5,
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    background: 'linear-gradient(145deg, #1A1A1A 0%, #222222 100%)',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    border: '1px solid rgba(212, 175, 55, 0.1)',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 12px 40px rgba(212, 175, 55, 0.15)',
                        border: '1px solid rgba(212, 175, 55, 0.2)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    textTransform: 'none',
                    fontWeight: 500,
                    padding: '8px 24px',
                    transition: 'all 0.3s ease-in-out',
                },
                contained: {
                    background: 'linear-gradient(45deg, #D4AF37 30%, #FFD700 90%)',
                    boxShadow: '0 3px 12px rgba(212, 175, 55, 0.2)',
                    '&:hover': {
                        background: 'linear-gradient(45deg, #B38F1C 30%, #C7A600 90%)',
                        boxShadow: '0 6px 20px rgba(212, 175, 55, 0.3)',
                    },
                },
                outlined: {
                    borderColor: '#D4AF37',
                    color: '#D4AF37',
                    '&:hover': {
                        borderColor: '#FFD700',
                        color: '#FFD700',
                        background: 'rgba(212, 175, 55, 0.05)',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: 'linear-gradient(90deg, #111111 0%, #1A1A1A 100%)',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.3)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#1A1A1A',
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: 12,
                        '& fieldset': {
                            borderColor: 'rgba(212, 175, 55, 0.2)',
                        },
                        '&:hover fieldset': {
                            borderColor: 'rgba(212, 175, 55, 0.4)',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D4AF37',
                        },
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
                outlined: {
                    borderColor: 'rgba(212, 175, 55, 0.3)',
                    '&:hover': {
                        borderColor: '#D4AF37',
                        backgroundColor: 'rgba(212, 175, 55, 0.05)',
                    },
                },
            },
        },
    },
});

export default theme;
